import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueLarge } from "../../images/index";
import {
  Image308,
  G9,
  G10,
  G11,
  G12,
  G13,
  Image309,
  Image310,
  Image340,
} from "../../images/Industries";
import { useEffect, useState } from "react";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";

const challenges = [
  "Legacy systems slowing down care delivery",
  "Growing cyber risks to sensitive patient data",
  "Complex compliance requirements (HIPAA, GDPR)",
  "Rising demand for telehealth and connected experiences",
  "Pressure to reduce costs while improving outcomes",
];

const healthCaare = [
  "Deep expertise in healthcare compliance & data security",
  "Experience serving providers, insurers, and pharma firms",
  "Hybrid U.S.–India teams for 24/7 delivery & support",
  "Innovation labs driving AI, automation, and digital health solutions",
];

const features = [
  {
    icon: G9,
    title: "Healthcare Cloud Migration",
    desc: "Secure, scalable infrastructure for hospitals & providers",
  },
  {
    icon: G10,
    title: "CyberSecurity & Compliance",
    desc: "End-to-end protection with HIPAA-ready frameworks",
  },
  {
    icon: G11,
    title: "AI & Data Analytics",
    desc: "Smarter decisions for patient care & drug discovery",
  },
  {
    icon: G12,
    title: "Telehealth & Remote Monitoring",
    desc: "Digital-first patient engagement models",
  },
  {
    icon: G13,
    title: "Workflow Automation",
    desc: "Streamlined hospital operations & faster clinical processes",
  },
];

function HLS() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[48rem] font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">
                  Healthcare & Life Sciences
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Safer, and Connected Healthcare Solutions
              </h1>
              <p className="text-md text-[#404040]">
                TechProjects partners with healthcare providers, pharma
                companies, and life sciences organizations to improve patient
                care, secure data, and accelerate innovation with digital
                technologies.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={Image340} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Industry Challenges
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {challenges.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image308}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            Our Digital Health Solutions
          </h2>
          <p className="text-center text-lg max-w-4xl mx-auto text-[#404040] mb-14 font-400">
            We empower businesses with AI-driven tools and automation that
            optimize operations, enhance customer experiences, and unlock
            measurable value across the supply chain:
          </p>

          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.slice(0, 3).map((feature, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center bg-white p-8"
              >
                <div className="mb-4">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-[50px] h-[50px]"
                  />
                </div>
                <div className="font-bold text-xl text-[#0F172A] mb-2 text-center">
                  {feature.title}
                </div>
                <div className="text-lg text-[#0F172A] text-center">
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            {features.slice(3).map((feature, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center bg-white p-8"
              >
                <div className="mb-4">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-[50px] h-[50px]"
                  />
                </div>
                <div className="font-bold text-xl text-[#0F172A] mb-2 text-center">
                  {feature.title}
                </div>
                <div className="text-lg text-[#0F172A] text-center">
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Why TechProjects for Healthcare?
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {healthCaare.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image309}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            Impact & Case Studies
          </h2>

          <div className="text-center text-lg text-[#404040] mb-12 font-400">
            We deliver measurable outcomes that drive efficiency, reduce costs,
            and create real business value. Here are a few examples of how
            TechProjects has helped clients transform with digital solutions.
          </div>

          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="flex-1 px-8 md:px-0">
              <ul className="list-disc space-y-4 text-lg text-[#0F172A]">
                <li>
                  <span className="font-bold">Healthcare Provider</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>30% lower IT costs</li>
                    <li>
                      Migrated to a secure cloud environment, improving
                      scalability and reliability.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold">Pharma Company</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>Faster drug trial insights</li>
                    <li>
                      Migrated to a secure cloud environment, improving
                      scalability and reliability.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold">Insurance Firm</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>40% faster claims processing</li>
                    <li>
                      Automated claims workflows, reducing manual effort and
                      improving turnaround time.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="flex-1 flex justify-center">
              <img
                src={Image310}
                alt="Case studies discussion"
                className="object-cover w-full max-w-md"
              />
            </div>
          </div>
        </section>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Healthcare & Life Sciences
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-4xl  mx-auto">
              With TechProjects, you can enhance clinical efficiency, improve
              care outcomes, and support personalized treatment — enabled by AI
              and intelligent automation.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default HLS;
